import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDWizardSubtitle } from 'Views/Page/Content/Modal/Layouts/FDWizardModalWrapper/Layout/FDWizardSubtitle';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => DialogTitle,
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDWizardSubtitle,
  }, overrideReadOnly)
  .override({ name: 'subtitle', hint: 'richtext' }, {
    _component: () => Richtext,
  }, overrideReadOnly);
